module.exports = __webpack_public_path__ + "img/sankaku_31_red.23deb615.png";